import { FiUsers, FiUserCheck, FiUserX, FiLogOut } from "react-icons/fi";

export const MESSAGES = {
  REQUEST_ERROR: "Fail to fetch attendance history",
  NO_REQUESTS_AVAILABLE: "No Attendance History",
  SITES_NAME_REQUIRED: "Site name is required",
  USER_REQUIRED: "User is required",
  SITE_SELECTION_REQUIRED: "Site selection is required",
  DATE_REQUIRED: "Date is required",
  TIME_REQUIRED: "Time is required",
  FUTURE_DATE_ERROR: "Date cannot be today or in the future",
  INVALID_SITE_ERROR: "Site boundary is invalid or not loaded.",
  LOCATION_DENIED_ERROR: "Cannot get location",
  SELFIE_REQUIRED: "Please take a selfie before submitting.",
  NOT_IN_SITE: "You are not within the selected site's geofence.",
  NOT_IN_SITE_RETRY: "You are not within the selected site's geofence. Kindly Retry..!",
  SUBMITTED_ATTENDANCE: (time) => `Attendance Submitted on ${time}` ,
  FAILED_SUBMISSION: "Failed to submit attendance.",
  SITES_ERROR: "Error fetching sites",
  LOCATION_NOT_AVAILABLE: "Location Not available.",
  PHOTO_NOT_AVAILABLE: "Photo Not available",
  MAP_LOADING_ERROR: "Error Loading Map",
  ATTENDANCE_ALREADY_EXISTS_RANGE: (inTime, outTime) =>
    `Attendance already exists for this date from ${inTime} to ${outTime}`,
  ATTENDANCE_ALREADY_EXISTS_CHECKIN: (inTime) =>
    `Attendance already exists for this date at ${inTime}`,
  LOCATION_REQUIRED: "Location Not available. Please enable GPS and retry again.",
  LOCATION_PERMISSION_DENIED:
    "Location permission was denied. Please enable location access for this app in your device settings, then retry.",
  LOCATION_SERVICES_DISABLED:
    "Location services (GPS) are turned off on this device. Please enable them and retry.",
  RETRY_LOCATION: "Retry Location",
  NO_DEFAULT_SITE_TITLE: "No Default Site Set",
  NO_DEFAULT_SITE_BODY:
    "You need a default site set on your Profile before you can check in or check out. Please set one and try again.",
  USER_DATA_ERROR: "Failed to fetch your profile details.",
};

export const ATTENDANCE_COLUMNS = [
  "site_name",
  "date",
  "checkin_time",
  "checkout_time",
  "is_backdated",
  "status",
  "actions",
];

export const ATTENDANCE_LABELS = {
  "site_name": "Site",
  "date": "Date",
  "checkin_time": "Check-in Time",
  "checkout_time": "Check-out Time",
  "is_backdated": "Backdated",
  "status": "Approval Status",
  "actions": "Actions"
};

export const ATTENDANCE_TYPES = {
  "CHECKIN": 'checkin',
  "CHECKOUT": 'checkout',
};

export const ADMIN_ATTENDANCE_TABLE_COLUMNS = [
  "user_name",
  "site_name",
  "date",
  "checkin_time",
  "checkout_time",
  "is_backdated",
  "status",
  "actions",
];

export const ADMIN_ATTENDANCE_COLUMN_LABELS = {
  user_name: "User",
  site_name: "Site",
  date: "Date",
  checkin_time: "Check-In Time",
  checkout_time: "Check-Out Time",
  is_backdated: "Backdated",
  status: "Status",
  actions: "Actions",
};

export const EXCEL_FILE_COLUMNS = [
  { label: "Site Name", value: "site_name" },
  { label: "User Name", value: "user_name" },
  { label: "Date", value: "date" },
  { label: "Check-In Time", value: "checkin_time" },
  { label: "Check-Out Time", value: "checkout_time" },
  { label: "Is Backdated", value: "is_backdated" },
  { label: "Status", value: "status" },
  { label: "Check IN Photo", value: "checkin_photo_url" },
  { label: "Check OUT Photo", value: "checkout_photo_url" },
]


export const ACTION_APPROVED = "approved";
export const ACTION_REJECTED = "rejected";

export const APPROVED = "APPROVED";
export const AUTO_APPROVED = "AUTO_APPROVED";
export const REJECTED = "REJECTED";
export const PENDING = "PENDING";
export const IN_PROGRESS = "IN_PROGRESS";
export const PENDING_L1_APPROVAL = "PENDING_L1_APPROVAL";
export const PENDING_L2_APPROVAL = "PENDING_L2_APPROVAL";
export const CORRECTED = "CORRECTED";

export const FILTER_FILEDS = ["status", "date"]
export const ATTENDANCE_ERROR = "Failed to fetch attendance data"
export const USERDATA_ERROR = "Failed to fetch user data"
export const ATTENDANCE_STATUS_ERROR = "Failed to update attendance status"
export const TASK_ERROR = "Failed to fetch task data"
export const TASK_WARNING = "Task not assigned for today"
export const INCOMPLETE_TASK_WARNING = "Assigned Task not completed"

export const getStatusBadgeClasses = (status) => {
  switch (status) {
    case APPROVED:
      return "bg-green-100 text-green-700";

    case AUTO_APPROVED:
      return "bg-emerald-100 text-emerald-700";

    case REJECTED:
      return "bg-red-100 text-red-700";

    case PENDING_L1_APPROVAL:
      return "bg-yellow-100 text-yellow-700";

    case PENDING_L2_APPROVAL:
      return "bg-orange-100 text-orange-700";

    case CORRECTED:
      return "bg-blue-100 text-blue-700";

    default:
      return "bg-gray-100 text-gray-600";
  }
};

// Toggle on the Attendance View page. ALL shows the attendance records table
// (all users, all days); the rest show the people behind the day's KPI counts.
export const KPI_VIEW = {
  CHECKED_IN: "checked_in",
  CHECKED_OUT: "checked_out",
  PENDING: "pending",
  ALL: "all",
};

// countKey: field in the KPI response shown as the badge on each toggle option.
// ALL has none; its badge is the attendance table's total record count instead.
export const KPI_VIEW_OPTIONS = [
  {
    value: KPI_VIEW.ALL,
    label: "History",
    countKey: null,
    dotClass: "bg-blue-500",
  },
  {
    value: KPI_VIEW.CHECKED_IN,
    label: "Checked In",
    countKey: "checked_in",
    dotClass: "bg-green-500",
  },
  {
    value: KPI_VIEW.CHECKED_OUT,
    label: "Checked Out",
    countKey: "checked_out",
    dotClass: "bg-purple-500",
  },
  {
    value: KPI_VIEW.PENDING,
    label: "Pending",
    countKey: "pending_checkin",
    dotClass: "bg-red-500",
  },
];

export const KPI_USER_COLUMNS = [
  "user_name",
  "date",
  "site_name",
  "checkin_time",
  "checkout_time",
  "status",
  "actions",
];

export const KPI_USER_LABELS = {
  user_name: "User",
  date: "Date",
  site_name: "Site",
  checkin_time: "Check-in Time",
  checkout_time: "Check-out Time",
  status: "Status",
  actions: "Actions",
};

// KPI cards on the Attendance View page, built from the KPI API response
export const getKpiCards = (kpi) => {
  // Checked in but not yet checked out. In the Total bar this sits first, then
  // checked out (purple), then pending (red), so green and red are never adjacent
  // (hard to tell apart for colour-blind users).
  const onSiteCount = Math.max(
    (kpi?.checked_in || 0) - (kpi?.checked_out || 0),
    0,
  );

  return [
    {
      label: "Total Users",
      value: kpi?.total_users,
      icon: FiUsers,
      colorClass: "bg-blue-100 text-blue-600",
      segments: [
        { value: onSiteCount, barClass: "bg-green-600" },
        { value: kpi?.checked_out || 0, barClass: "bg-purple-600" },
        { value: kpi?.pending_checkin || 0, barClass: "bg-red-600" },
      ],
      caption: `${onSiteCount} on site · ${kpi?.checked_out ?? 0} checked out · ${kpi?.pending_checkin ?? 0} pending`,
    },
    {
      label: "Checked In",
      value: kpi?.checked_in,
      icon: FiUserCheck,
      colorClass: "bg-green-100 text-green-600",
      total: kpi?.total_users,
      barClass: "bg-green-600",
      caption: `${kpi?.checked_in ?? 0} checked in out of ${kpi?.total_users ?? 0}`,
    },
    {
      label: "Checked Out",
      value: kpi?.checked_out,
      icon: FiLogOut,
      colorClass: "bg-purple-100 text-purple-600",
      total: kpi?.checked_in,
      barClass: "bg-purple-600",
      caption: `${kpi?.checked_out ?? 0} checked out of ${kpi?.checked_in ?? 0} checked in`,
    },
    {
      label: "Pending Check In",
      value: kpi?.pending_checkin,
      icon: FiUserX,
      colorClass: "bg-red-100 text-red-600",
      total: kpi?.total_users,
      barClass: "bg-red-600",
      caption: `${kpi?.pending_checkin ?? 0} pending out of ${kpi?.total_users ?? 0}`,
    },
  ];
};
